import React from "react";
import Loadable from "react-loadable"
import CreateGroup from "./views/GroupsV2/create/createGroupV2";

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import("./views/Dashboard/Dashboard"),
  loading: Loading,
});

const Groups = Loadable({
  loader:()=>import("./views/Groups/list/UserGroups"),
  loading: Loading,
});

const CreateTenant = Loadable({
  loader:()=>import("./views/Groups/create/createGroup"),
  loading: Loading,
});
const ListGroupsV2 = Loadable({
  loader:()=>import("./views/GroupsV2/list/listGroup"),
  loading: Loading,
});
const CreateGroupsV2 = Loadable({
  loader:()=>import("./views/GroupsV2/create/createGroupV2"),
  loading: Loading,
});

const ViewEdit = Loadable({
  loader:()=>import("./views/GroupsV2/ViewEdit/viewEdit"),
  loading: Loading,
});
const UserGroupEdit = Loadable({
  loader:()=>import("./views/Groups/edit/EditUserGroup"),
  loading: Loading,
});
const Users = Loadable({
  loader:()=>import("./views/Users/list/Users"),
  loading: Loading,
});
const InviteUser = Loadable({
  loader:()=>import("./views/Users/invite/InviteUser"),
  loading: Loading,
});
const EditUser = Loadable({
  loader:()=>import("./views/Users/edit/EditUser"),
  loading: Loading,
});
const UserProfile = Loadable({
  loader:()=>import("./views/Users/profile/Profile"),
  loading: Loading,
});

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: "/", exact: true, name: "Home", component: Dashboard },
  { path: "/app/tenants", exact: true, name: "Tenant(s)", component: Groups },
  { path: "/app/v2/groups", exact: true, name: "Groups", component: ListGroupsV2 },
  { path: "/app/v2/groups/create-group", exact: true, name: "Create Groups", component: CreateGroupsV2 },
  { path: "/app/create-tenant", exact: true, name: "Create Tenant", component: CreateTenant },
  { path: "/app/v2/groups/edit", exact: true, name: "Edit Groups", component: ViewEdit },
  { path: "/app/usergroups/:groupUuid/edit", exact: true, name: "Edit Group", component: UserGroupEdit },
  { path: "/app/usergroups/:groupUuid/users", exact: true, name: "Users", component: Users },
  { path: "/app/usergroups/:groupUuid/users/invite", exact: true, name: "Invite User", component: InviteUser },
  { path: "/app/usergroups/:groupUuid/users/:userUuid/edit", exact: true, name: "Edit User", component: EditUser },
  { path: "/app/usergroups/:groupUuid/users/:userUuid/power-edit", exact: true, name: "Power Edit", component: EditUser },
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  { path: "/app/profile/edit", exact: true, name: "User Profile", component: UserProfile },

];

export default routes;
